import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { socket, validateNewPasswords } from "../utils/utils"
import { useAppSelector } from "@/store/hooks"

interface SetNewPasswordProps {}

const SetNewPassword: React.FC<SetNewPasswordProps> = () => {
  const [pass, setPass] = useState("")
  const [pass2, setPass2] = useState("")
  const forgetPasswordEmail = useAppSelector(
    (state) => state.global.forgetPasswordEmail
  )
  const nav = useNavigate()
  const handleUpdatePassword = () => {
    const passwordsValidated = validateNewPasswords(pass, pass2)
    if (!passwordsValidated) return

    socket.emit(
      "resetNewPassword",
      {
        email: forgetPasswordEmail,
        pass,
      },
      (res) => {
        if (res) {
          nav("/login")
        }
      }
    )
  }
  return (
    <>
      <div>Write a new password</div>
      <input
        value={pass}
        onChange={(e) => setPass(e.target.value)}
        data-testid="set-new-password"
      />
      <input
        value={pass2}
        onChange={(e) => setPass2(e.target.value)}
        data-testid="confirm-set-new-password"
      />
      <button data-testid="set-new-pass-btn" onClick={handleUpdatePassword}>
        Reset Password
      </button>
    </>
  )
}

export default SetNewPassword
